export default __webpack_public_path__ + "static/media/54.bad46a6f.svg";